import { styled } from 'styled-components'
import { Tabs } from '@mui/material'

export const StyledTabs = styled(Tabs)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`
